import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';

import { SiterecordIdChange } from 'app/models/siterecord-id-change.model';

@Component({
  selector: 'app-dialog-edit-location-id',
  templateUrl: './dialog-edit-location-id.component.html',
  styleUrls: ['./dialog-edit-location-id.component.scss']
})
export class DialogEditLocationIdComponent implements OnInit {
  @ViewChild('confirmRecordIdDialog') confirmRecordIdDialog: ModalDirective;
  @ViewChild('recordIdForm') public recordIdForm: NgForm = null;

  @Input() recordId: string;
  @Input() canMarkInternal: boolean;
  @Input() isExportedToNcis: boolean;

  @Output() onConfirm = new EventEmitter<SiterecordIdChange>();
  @Output() onCancel = new EventEmitter<SiterecordIdChange>();

  private recordIdNotNewValueError: string;

  public isInternal = false;

  constructor(protected readonly translateService: TranslateService) {}

  ngOnInit() {
    this.initializeErrorMessage();
  }

  public show(): void {
    this.confirmRecordIdDialog.show();
  }

  public confirm(): void {
    const recordId = this.recordIdForm.value.recordId;
    const newRecordIdComment = this.recordIdForm.value.siteRecordComment;
    const isInternal = this.isInternal;

    this.recordIdForm.reset();

    this.confirmRecordIdDialog.hide();
    this.onConfirm.emit(new SiterecordIdChange(recordId, newRecordIdComment, isInternal));
  }

  public cancel(): void {
    this.confirmRecordIdDialog.hide();
  }

  protected translate(valueToTranslate: string): Observable<string> {
    return this.translateService.get(valueToTranslate);
  }

  private initializeErrorMessage(): void {
    this.translate('ERROR.FE005').subscribe(translation => (this.recordIdNotNewValueError = translation));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-edit-location-id/dialog-edit-location-id.component.ts